export const ADD_FEATURE_TO_LAND_ASSEMBLY = 'ADD_FEATURE_TO_LAND_ASSEMBLY';
export const REMOVE_FEATURE_FROM_LAND_ASSEMBLY = 'REMOVE_FEATURE_FROM_LAND_ASSEMBLY';
export const TOGGLE_LAND_ASSEMBLY_FEATURES = 'TOGGLE_LAND_ASSEMBLY_FEATURES';
export const SET_LAND_ASSEMBLY_FEATURES = 'SET_LAND_ASSEMBLY_FEATURES';
export const SET_LAND_ASSEMBLY_LAYER = 'SET_LAND_ASSEMBLY_LAYER';

export const FETCH_STATS_REQUEST = 'FETCH_STATS_REQUEST';
export const FETCH_STATS_SUCCESS = 'FETCH_STATS_SUCCESS';
export const FETCH_STATS_FAILURE = 'FETCH_STATS_FAILURE';

export const SET_SITE_CARD_CREATOR_OPEN = 'SET_SITE_CARD_CREATOR_OPEN';